export class EventTypeInputExcludeTimeEventTypeMap {
    constructor(eventTypeInputExcludeTimeEventTypeMapId: number, eventTypeId: number, fromEventTypeId: number, toEventTypeId: number) {
        this.eventTypeInputExcludeTimeEventTypeMapId = eventTypeInputExcludeTimeEventTypeMapId;
        this.eventTypeId = eventTypeId;
        this.fromEventTypeId = fromEventTypeId;
        this.toEventTypeId = toEventTypeId;
    }
    eventTypeInputExcludeTimeEventTypeMapId: number;
    eventTypeId: number;
    fromEventTypeId: number;
    toEventTypeId: number;
}
